<script lang="ts">
	import { browser } from '$app/env';
	import { page } from '$app/state';
	import { adminStore } from '#lib/stores/admin.js';
	import { appDataLoaded } from '#lib/stores/app.js';
	import { businessStore } from '#lib/stores/business.js';
	import { chatEnabled, chatSupportHasMessageStore, chattingWithUser } from '#lib/stores/chat.js';
	import { hasConfigurationIssues } from '#lib/stores/settings.js';
	import { userStore } from '#lib/stores/user.js';
	import { Crisp, EventsColors } from 'crisp-sdk-web';
	import { onMount } from 'svelte';

	let loaded = $state(false);
	let mounted = $state(false);
	let currentBusinessId = $state<string | undefined>();
	let previousTrackedUrl: string | null = null;

	// Send the current urls in Crisp
	$effect(() => {
		const currentPath = page.url.pathname;
		if (browser && loaded && currentPath !== previousTrackedUrl) {
			previousTrackedUrl = currentPath;
			Crisp.session.pushEvent('navigate_to_page', { url: currentPath }, EventsColors.Green);
		}
	});

	function mountChat() {
		Crisp.message.onMessageReceived(() => {
			if (!$chatEnabled) {
				$chatSupportHasMessageStore = true;
			}
		});

		// Callback when chat is loaded
		Crisp.session.onLoaded(() => {
			loaded = true;
			if (Crisp.chat.unreadCount() > 0) {
				$chatSupportHasMessageStore = true;
			}
		});

		// Keep chat open in the app if user opens it
		Crisp.chat.onChatOpened(() => {
			$chattingWithUser = true;
		});
		Crisp.chat.onChatClosed(() => {
			$chattingWithUser = false;
		});

		Crisp.chat.hide();
		Crisp.chat.close();
		mounted = true;
	}

	// Initialize Crisp
	onMount(() => {
		Crisp.configure('4abff3b1-d336-4eaf-ab64-67c18ba5f2ab', {
			sessionMerge: true,
			safeMode: true
		});
		loaded = true;

		if (localStorage.getItem('chatSupportHasMessageStore')) {
			$chatSupportHasMessageStore = true;
		}
	});

	function updateChat() {
		if (!browser) return;
		if ($chatEnabled) {
			Crisp.chat.show();
			if ($chattingWithUser) {
				Crisp.chat.open();
			}
		} else {
			Crisp.chat.hide();
		}
	}

	$effect(() => {
		if (!mounted && loaded) {
			mountChat();
			updateChat();
		} else if (
			!$adminStore &&
			mounted &&
			$businessStore.id &&
			currentBusinessId !== $businessStore.id
		) {
			currentBusinessId = $businessStore.id;
			Crisp.setTokenId($businessStore.id);
			Crisp.user.setEmail($userStore.email);
			Crisp.user.setPhone($userStore.phone);

			if ($businessStore.logo) {
				Crisp.user.setAvatar($businessStore.logo.replace('.dev', '.com'));
			}
			Crisp.user.setNickname(
				$userStore.firstName + ' ' + $userStore.lastName + ' (' + $businessStore.name + ')'
			);
			Crisp.session.reset();
			updateChat();
		}
	});

	$effect(() => updateChat());

	$effect(() => {
		const _loaded = $appDataLoaded;
		const routeId = page.route.id;

		if (routeId?.startsWith('/(app)/qr-code')) {
			$chatEnabled = false;
		} else if (
			$hasConfigurationIssues ||
			(routeId && !routeId.startsWith('/(app)/(connected)/(app)'))
		) {
			$chatEnabled = true;
		}
	});

	$effect(() => {
		if ($chatSupportHasMessageStore) {
			localStorage.setItem('chatSupportHasMessageStore', 'true');
		} else if (browser) {
			localStorage.removeItem('chatSupportHasMessageStore');
		}
	});
</script>
